import { styled, Box, IconButton } from "@mui/material";
import { dumontColors } from "../../colors";

export const HeaderContainer = styled(Box)<{ isFullscreen?: boolean; showBackButton: boolean }>(
  ({ isFullscreen, showBackButton }) => ({
    height: 24,
    display: "flex",
    alignItems: "center",
    justifyContent: showBackButton ? "space-between" : "flex-end",
    padding: isFullscreen ? "12px 24px" : "12px",
    marginTop: "12px",
  })
);

export const BackButton = styled(IconButton)({
  width: 24,
  height: 24,
  backgroundColor: "rgba(0, 0, 0, 0.02)",
  border: "1px solid rgba(0, 0, 0, 0.04)",
  borderRadius: "4px",
  "&:hover": {
    backgroundColor: "rgba(0, 0, 0, 0.04)",
  },
});

export const ActionIconButton = styled(IconButton)({
  width: 24,
  height: 24,
  backgroundColor: "rgba(0, 0, 0, 0.02)",
  border: "1px solid rgba(0, 0, 0, 0.04)",
  borderRadius: "4px",
  "&:hover": {
    backgroundColor: "rgba(0, 0, 0, 0.04)",
  },
});

export const CloseButton = styled(Box)({
  width: 62,
  height: 24,
  backgroundColor: dumontColors.gray50,
  border: `1px solid ${dumontColors.borderLight}`,
  borderRadius: "4px",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  gap: "9px",
  padding: "10px",
  cursor: "pointer",
  "&:hover": {
    backgroundColor: dumontColors.borderLight,
  },
});

export const Divider = styled(Box)({
  width: "0px",
  height: "10px",
  borderLeft: "0.8px solid rgba(102, 112, 133, 0.8)",
});
